import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UsuariosService } from '~shared/servicios/usuarios.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @ViewChild('#menu') sidenav;
  db: string;

  constructor(private usuarioService: UsuariosService, private router: Router) {
    router.events.subscribe((val) => {
      jQuery(document).ready(function () {
        $("#checkMenu").prop("checked", false);
      });
    });
  }

  ngOnInit(): void {
    this.usuarioService.getBase().subscribe((data) => {
      //console.log(data);
      this.db = data[0].database_type;
    });
  }

}
